import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { AdvertisementBanner } from '@app/api/models';
import { PublicEndpointsService } from '@app/api/services';

import { AdBannerActions } from './ad-banner.slice';

@Injectable({ providedIn: 'root' })
export class AdBannerEffects {
  loadAdBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdBannerActions.loadAdBanners.trigger),
      switchMap((_action) =>
        this.publicService
          .getPackagingUnitAdvertisementBanners({
            randomize: true,
            limit: 10,
          })
          .pipe(
            map((adBanners: Array<AdvertisementBanner>) =>
              AdBannerActions.loadAdBanners.success({ response: adBanners })
            )
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private publicService: PublicEndpointsService
  ) {}
}
